import _ from 'lodash'
import templateUrl from './shippingParcel.view.html'

/**
 * Stock detail Report route
 *
 * @namespace routes.ReportStockView
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.shippingParcels.view',
  label: 'REPORT.SHIPPINGPARCELS.VIEW.TITLE',
  component: 'tmrReportShippingParcelView',
  abstract: false,
  accessControl: 'TmrShippingOperationsAccessControl',
  data: {
    capabilities: ['Resource.view', 'Resource.ShippingParcel.view'],
  },
}

/**
 * Component for {@link routes.tmrReportStockView Stock Report route}
 *
 * @type {ngComponent}
 */
export const tmrReportShippingParcelView = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrReportShippingParcelViewController',
  bindings: {
    resource: '<',
    resourceListTitle: '<?',
    resourceListSref: '@?',
    drilldown: '<?',
  },
}

/**
 * Controller of component {@link tmrReportShippingParcelView}.
 *
 * @type {ngController}
 */
export class tmrReportShippingParcelViewController {
  static ngType = 'controller'

  constructor(tmrShippingParcelStates) {
    'ngInject'
    Object.assign(this, { shippingParcelStates: tmrShippingParcelStates })
  }

  $onInit() {
    this.details = [
      { label: 'REPORT.SHIPPINGPARCELS.VIEW.CODE', value: this.resource.code },
      {
        label: 'REPORT.SHIPPINGPARCELS.VIEW.NOTICE',
        value: this.resource.shippingNotice.code,
      },
      {
        label: 'REPORT.SHIPPINGPARCELS.VIEW.CREATED',
        value: this.resource.creationDate,
        filter: 'tmrDate',
      },
    ]

    const originPlace = this.resource.shippingNotice.originPlace
    const destinationPlace = this.resource.shippingNotice.destinationPlace
    const destinationZone = this.resource.shippingNotice.destinationZone
    if (originPlace)
      this.details.push({
        label: 'REPORT.SHIPPINGPARCELS.VIEW.ORIGINPLACE',
        value: originPlace.$getLabel(),
      })
    if (destinationPlace)
      this.details.push({
        label: 'REPORT.SHIPPINGPARCELS.VIEW.DESTINATIONPLACE',
        value: destinationPlace.$getLabel(),
      })
    if (destinationZone)
      this.details.push({
        label: 'REPORT.SHIPPINGPARCELS.VIEW.DESTINATIONZONE',
        value: destinationZone.$getLabel(),
      })

    this.outbound = this.resource.$outbound
    this.inbound = this.resource.$inbound
    if (this.inbound) this.tab = 'inbound'
    else if (this.outbound) this.tab = 'outbound'
    this.outboundCounters = this.resource.$outboundCounters
    this.inboundCounters = this.resource.$inboundCounters
    this.outboundDetails = this.operationDetails(this.outbound)
    this.inboundDetails = this.operationDetails(this.inbound)
  }

  operationDetails(operation) {
    if (!operation) return []

    const iteratee = item => item.productCode ?? item.upc

    const {
      detectedItems,
      detectedUpcs,
      expectedItems,
      expectedUpcs,
      products,
    } = operation.details

    const detected = _.groupBy([...detectedItems, ...detectedUpcs], iteratee)
    const expected = _.groupBy([...expectedItems, ...expectedUpcs], iteratee)
    const codes = _.uniq(Object.keys(detected), Object.keys(expected))
    const rows = codes.map(code => ({
      code,
      detected: this.countDetailsItems(detected[code]),
      expected: this.countDetailsItems(expected[code]),
      unexpected: this.countDetailsItems(
        detected[code].filter(({ expected }) => !expected)
      ),
      description: products?.[code].description,
      size: products?.[code].size,
      color: products?.[code].color,
    }))

    return rows
  }

  /** Count helper for operationDetails */
  countDetailsItems(items) {
    return (items ?? []).reduce(
      (count, item) => count + (item.quantity ?? 1),
      0
    )
  }
}
